import React, { useEffect, useState, useRef } from "react";
import { keyBy } from "lodash";

import { API, graphqlOperation } from "aws-amplify";
import { serviceByAccountByStatusByName } from "../../../graphql/queries";

import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  useNotify,
  useShowController,
  ArrayField,
  Datagrid,
  FunctionField,
  Loading,
  NumberField,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";

import { logError } from "../../../utils/appUtils";
import { ServiceStatus } from "../../../utils/constants";

const useStyles = makeStyles((theme) => ({
  totals: {
    marginRight: theme.spacing(2),
    textAlign: "right",
  },
}));

export const InvoicePeak = (props) => {
  const classes = useStyles();
  const notify = useNotify();
  const isComponentMounted = useRef(true);
  const { record } = useShowController(props);
  const [services, setServices] = useState({});

  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  const serviceRender = (record) =>
    `${services[record.serviceId] ? services[record.serviceId]?.name : ""}`;

  useEffect(() => {
    if (isComponentMounted && record) getServices();
    return () => (isComponentMounted.current = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const getServices = async () => {
    try {
      debugger;
      setLoading(true);
      let resp = await API.graphql(
        graphqlOperation(serviceByAccountByStatusByName, {
          accountId: record.accountId,
          statusName: { beginsWith: { status: ServiceStatus.AVAILABLE } },
          sortDirection: "ASC",
        })
      );
      let serviceData = resp.data.serviceByAccountByStatusByName?.items;
      setServices(keyBy(serviceData, "id"));
    } catch (err) {
      setError(true);
      logError("invoices:InvoiceShow:getServices", err, notify);
    }
    setLoading(false);
  };

  if (loading) return <Loading />;
  if (!record || !record?.lineItems || error) return null;
  return (
    <Show {...props} title=" " actions={false}>
      <SimpleShowLayout>
        <ArrayField source="lineItems.items" label=" " fullWidth>
          <Datagrid>
            <FunctionField
              source="serviceId"
              label="Goods & Services"
              render={serviceRender}
              sortable={false}
            />
            <TextField source="serviceNote" label="Notes" sortable={false} />
            <NumberField source="quantity" label="Qty." sortable={false} />
            <TextField source="units" label="UOM" sortable={false} />
            <NumberField
              source="unitCost"
              label="Unit Cost"
              sortable={false}
              options={{
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }}
            />
            <NumberField
              source="itemTax"
              label="Tax"
              sortable={false}
              options={{
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }}
            />
            <NumberField
              source="amount"
              label="Amount Due"
              sortable={false}
              options={{
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }}
            />
          </Datagrid>
        </ArrayField>
        <Grid container direction="row" spacing={1}>
          <Grid item xs={12}>
            <Typography className={classes.totals}>
              SUBTOTAL: {`${formatter.format(record.subtotal)}`}{" "}
            </Typography>
            <Typography className={classes.totals}>
              TAX: {`${formatter.format(record.tax)}`}{" "}
            </Typography>
            <Typography className={classes.totals}>
              TOTAL: {`${formatter.format(record.total)}`}{" "}
            </Typography>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};
